import Cookies from 'js-cookie';

const SameSite = "SameSite=None; secure;";


export function setCredentials(username, session)
{
    /*

        username : String.
        session : Boolean. If true the cokkies will be a session cookie.
        Set the user credentials in cookie.
    */
   if (!session)
   {
    Cookies.set('username', username, { expires: 30 })  //valid 30 days.
   }
   else
   {
    Cookies.set('username', username)  //session cookie. will be deleted when restarting the browser.
   }
    window.location.reload(false);
}

export function getUsername()
{
    return Cookies.get("username");
}

export function updateEmailCookie(newmail)
{
    Cookies.set('username', newmail, { expires: 30})
}

export function isConnected()
{
    //Return whether the user is connected (based on cookie) or not.
    // !!!! warning : there is no verification to check if we are connected from the server point of view !!!!
    if (getUsername() === undefined)
    {
        return false;
    }
    setLang(getLang())  //update the duration of lang cookie
    return true;
}
  
export function disconnect()
{
    Cookies.remove("username");
    Cookies.remove("session");
    window.location.reload(false);
}


/* function not used as of now but added in view of creating a button to select the lang */
export function setLang(lang)
{
    /*
    lang : String.
    */
    //some navigators limit the expiration date to be at max 400 days.
    Cookies.set('lang', lang, { expires: 400 })
}

/* function not used as of now but added in view of creating a button to select the lang */
export function getLang()
{
    if (Cookies.get("lang") == undefined){
        return ""
    }
    return Cookies.get("lang");
}
